import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import useTelegramAuth from "../hooks/useTelegramAuth";
import { Loader } from "../components/ui";

import {
  ChevronRightIcon,
  ClockIcon,
  HeartIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";

const ProfilePage = () => {
  const { isAuthReady } = useTelegramAuth();
  const [user, setUser] = useState(null);
  const favoritesCount = useSelector((state) => state.favorites.items.length);

  useEffect(() => {
    if (!isAuthReady) return;

    const u = localStorage.getItem("user");
    if (u) {
      setUser(JSON.parse(u));
    }
  }, [isAuthReady]);

  if (!isAuthReady) {
    return <Loader className="min-h-[60vh]" />;
  }

  const items = [
    { icon: ClockIcon, text: "История заказов", to: "/orders" },
    { icon: HeartIcon, text: "Избранное", to: "/favorites", badge: favoritesCount },
    { icon: MapPinIcon, text: "Мои адреса", to: "/profile/addresses" },
  ];

  return (
    <div className="text-slate-100 flex flex-col">

      <main className="max-w-xl mx-auto w-full">

        {/* USER */}
        <section className="p-6 flex flex-col items-center">

          <div className="mb-4">

            <div className="w-28 h-28 rounded-full bg-slate-800 flex items-center justify-center border-2 border-primary/50 shadow-lg shadow-primary/20 overflow-hidden">

              {user?.telegram_photo_url ? (
                <img
                  src={user.telegram_photo_url}
                  alt="avatar"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-4xl font-bold text-slate-400">
                  {user?.first_name?.[0] || "U"}
                </span>
              )}

            </div>

          </div>

          <h2 className="text-2xl font-bold text-center">
            {user?.first_name} {user?.last_name}
          </h2>

          {user?.tg_username && (
            <p className="text-slate-400 text-sm mt-1">
              @{user.tg_username}
            </p>
          )}

        </section>

        {/* ACCOUNT */}
        <nav className="px-4 space-y-3 mb-10">

          <h3 className="px-2 text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">
            Аккаунт
          </h3>

          {items.map((item, i) => {
            const Icon = item.icon;

            return (
              <Link
                to={item.to || '#'}
                key={i}
                className="
                flex
                items-center
                justify-between
                p-4
                bg-slate-900/80
                border border-slate-700
                rounded-2xl
                hover:bg-slate-800
                hover:border-slate-500
                transition
                "
              >

                <div className="flex items-center gap-4">

                  <div className="w-10 h-10 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center text-blue-400">
                    <Icon className="w-5 h-5" />
                  </div>

                  <span className="font-medium">
                    {item.text}
                  </span>

                </div>

                <div className="flex items-center gap-2">
                  {item.badge > 0 && (
                    <span className="bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
                      {item.badge}
                    </span>
                  )}
                  <ChevronRightIcon className="w-5 h-5 text-slate-400" />
                </div>

              </Link>
            );
          })}

        </nav>

      </main>

    </div>
  );
};

export default ProfilePage;